// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'Toggle',
    mixins: [
        template,
    ]
})
export class Toggle extends Vue {

    public get themeMap() {
        const themeMap = {
            default: 4,
            secondary: 5,
        }

        return themeMap[this.theme] ? themeMap[this.theme] : themeMap['default']
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0  ? `wb-e-inp-${this.themeMap}--has-error` : ''
    }

    @Prop({default: false})
    public value!: boolean

    @Prop()
    public label!: string

    @Prop()
    public theme!: string

    @Prop()
    public disabled?: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    public created () {

    }

    public handleToggleClick(e: Event) {
        this.$emit('input', !this.value)
    }
}